import React, { useState } from 'react';
import AdminLayout from '../../components/layout/admin';
import { Box, Grid, Group, Space, Table, Text, Title } from '@mantine/core';
import Card from '../../components/elements/Card';
import * as Unicons from '@iconscout/react-unicons';
import { useHistory, Link } from 'react-router-dom';
import { HiOutlineArrowTopRightOnSquare } from 'react-icons/hi2';
import { useDisclosure } from '@mantine/hooks';
import { useQuery } from '@tanstack/react-query';
import { getRedeem, getRnB } from '../../services/profile';
import { getSharepointCdnFile } from '../../utilities';
import { getDataInterestUser } from '../../services/navbar';
import ModalInterest from '../../components/layout/admin/elements/HeaderNavigation/ModalInterest';
import ModalChangeInterest from '../edit_profile_user/ModalChangeInterest';
import { ApiService } from '../../constants';
import Button from '../../components/elements/Button';
import LoadingIllustration from '../../components/fragments/IllustrationState/LoadingIllustration';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import DataTables from '../../components/elements/DataTables';
import TableImage from '../../components/fragments/TableImage';
import LabelDate from '../../components/fragments/LabelDate';
import { listUser } from '../../services/syncUser';

const ListSyncUserPage = (props) => {
  const [openedInterest, { toggle: toggleInterest }] = useDisclosure(false);

  const columns = [
    {
      heading: 'Old Email',
      props: 'emailFrom',
      id: 'emailFrom',
      sortable: true
    },
    {
      heading: 'New Email',
      props: 'emailTo',
      id: 'emailTo',
      sortable: true
    },
    {
      heading: 'Updated At',
      props: (item) => renderDate(item, 'dateIn'),
      id: 'dateIn',
      sortable: true
    }

    // {
    //   heading: 'Action',
    //   props: 'action',
    //   sortable: false
    // }
  ];

  const renderDate = (item, key) => <LabelDate date={item[key]} />;

  const [modalConfig, setModalConfig] = useState({
    show: false,
    data: null,
    type: ''
  });

  const fetchedDataListUser = useQuery({
    queryKey: [`interestUser`, props.auth?.email],
    queryFn: () => listUser(props.auth?.email),
    enabled: true
  });

  console.log(fetchedDataListUser.data?.data?.data);

  const loadingState =
    fetchedDataListUser.isLoading || fetchedDataListUser.isLoading;

  return (
    <>
      <AdminLayout>
        <Breadcrumbs
          pageTitle="Overview"
          itemList={[
            {
              title: 'Back Office BCL&D',
              href: '#',
              icon: <Unicons.UilFileCopyAlt size={16} />
            },
            {
              title: 'History Sync User',
              href: '/management/history-sync-user'
            }
          ]}
        />
        {loadingState && (
          <LoadingIllustration
            description="Please wait... Currently collecting data..."
            title="Preparing Data"
          />
        )}
        {!loadingState && (
          <>
            <Card>
              <Title order={4}>History Sync User</Title>
              <Text size="sm" mb={10}>
                Below is the list of history sync user.
              </Text>
              <DataTables
                columns={columns}
                loading={false}
                data={fetchedDataListUser.data?.data?.data || []}
                // handleDelete={(data) => {
                //   setModalConfig({
                //     show: true,
                //     data: data,
                //     type: 'delete'
                //   });
                // }}
                // handleEdit={(data) => {
                //   setModalConfig({
                //     show: true,
                //     data: data,
                //     type: 'edit'
                //   });
                // }}
              />
            </Card>
          </>
        )}
      </AdminLayout>
      <ModalChangeInterest
        onClose={() => toggleInterest()}
        opened={openedInterest}
      />
    </>
  );
};

export default ListSyncUserPage;
